import { FormattedMessage } from 'react-intl';
import { Button } from '@odmonorepo/core-components';
import { Card, Stack } from 'react-bootstrap';
import { useApplication } from 'merchant-api/unified';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useParties } from 'merchant-api/spiceroad';
import { queryClient, unifiedApiClient } from 'merchant-api';
import { selectedOfferIdAtom, getDetailedOffersOpts } from 'merchant-api/offer';
import { Application } from 'merchant-api/types';
import { useSetAtom } from 'jotai';

export const ApplicationExpiredError = () => {
  const navigate = useNavigate();
  const { applicationData, isLoadingApplication } = useApplication();
  const { partyId, isLoadingParties } = useParties();
  const setSelectedOfferId = useSetAtom(selectedOfferIdAtom);
  const { mutate: createApp, isPending } = useMutation({
    mutationFn: async (partyId?: string) => {
      const { data } = await unifiedApiClient.POST('/client/application/v1/create', { body: { partyId } as never });
      // Butterfly init can answer 201 without echoing the app, so refetch instead of seeding the cache.
      queryClient.invalidateQueries({ queryKey: ['app'] });
      return data as unknown as Application;
    },
    onSuccess: async (data) => {
      setSelectedOfferId(null);
      await queryClient.invalidateQueries(getDetailedOffersOpts(applicationData?.id));
      navigate({ to: '/application/$id/renewal', params: { id: data.id } })
    },
    onError: (error) => { throw error }
  });
  
  const handleApplyNow = () => {
    applicationData?.type === 'RENEWAL' ? createApp(partyId) : navigate({ to: '/apply/landing' });
  };

  return (
    <div className="text-center" style={{ paddingTop: 32 }}>
      <div className="h3 mb-5 mx-3">
        <FormattedMessage id="customError.applicationExpired.pageTitle" />
      </div>
      <Stack gap={5} className="pt-3 m-0 mx-auto" style={{ maxWidth: 600, width: '100%' }}>
        <Card className="pt-4 pb-4 px-4">
          <div className="mx-5 px-sm-5 py-5 text-start">
            <div className="h4 mb-3">
              <FormattedMessage id="customError.applicationExpired.title" />
            </div>
            <div className="mb-4">
              <FormattedMessage id="customError.applicationExpired.message" />
            </div>
            <Button 
              type="button" 
              className="mt-3 w-100" 
              onClick={handleApplyNow}
              disabled={isLoadingParties || isLoadingApplication}
              loading={isPending}
            >
              <FormattedMessage id="customError.applicationExpired.cta" />
            </Button>
          </div>
        </Card>
      </Stack>
    </div>
  );
}

export default ApplicationExpiredError;

